module.exports = __webpack_public_path__ + "img/1-11.f893cda6.png";